export default __webpack_public_path__ + "static/media/owl-icon.6e7a5010.svg";